import React, { memo, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { useEditRoleContext } from 'lib/context/Role/EditRoleContext/EditRoleContext';
import { useNewRoleContext } from 'lib/context/Role/NewRoleContext/NewRoleContext';
import { useRoleList } from 'lib/hooks/queries/roles/useRoleList';

import { currentPractice } from 'components/practice/practiceState';
import state from 'components/state';

import AgTablePage from '../AgTablePage/AgTablePage';

import EditRoleModal from './components/EditRole/EditRoleModal';
import HeaderActions from './lib/HeaderActions';
import NewRoleModal from './lib/NewRoleModal';
import { DEFAULT_FILTERS } from './lib/defaultFilters';
import { defaultColumns } from './lib/helper';

const Table = ({ isAdmin, forAdmin }) => {
  const [rowData, setRowData] = useState({});
  const { setShowNewRoleModal } = useNewRoleContext();
  const { showEditRoleModal, setShowEditRoleModal, formik } = useEditRoleContext();
  const permissions = useRecoilValue(state.permissions);
  const currPractice = useRecoilValue(currentPractice);
  const practiceTimezone = currPractice.timezone;
  const [columns, setColumns] = useState(defaultColumns(permissions, practiceTimezone));

  const { id } = useParams();

  useEffect(() => {
    setColumns(() => defaultColumns(permissions, practiceTimezone, isAdmin, forAdmin));
  }, [permissions]);

  const onCellClicked = (e) => {
    if (e) {
      formik.resetForm();
      setShowEditRoleModal(true);
      setRowData(e);
    }
  };

  return (
    <>
      <AgTablePage
        title="Roles & Permissions"
        onSelectRow={onCellClicked}
        rightHeaderActions={
          <HeaderActions
            forAdmin
            onAddNewRoleClick={() => {
              setShowNewRoleModal(true);
            }}
          />
        }
        rowStyle={{ cursor: 'pointer' }}
        defaultColumns={columns}
        defaultFilters={DEFAULT_FILTERS}
        useData={useRoleList}
        queryParams={{
          practiceId: id,
          forAdmin
        }}
        name="role_list"
        keepOldFilters={isAdmin}
      />
      {showEditRoleModal && (
        <EditRoleModal
          showModal={showEditRoleModal}
          hideModal={() => setShowEditRoleModal(false)}
          roleName={rowData?.name}
          roleType={rowData?.type}
          roleDescription={rowData?.description}
          roleId={rowData?.id}
          isAdmin={isAdmin}
          forAdmin={forAdmin}
        />
      )}
      <NewRoleModal forAdmin={forAdmin} />
    </>
  );
};

export default memo(Table);
